export default __webpack_public_path__ + "static/media/service-new.752512bd.svg";